import React from "react";
import {motion} from "framer-motion"
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2016 - 2024</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="CTO/Product Manager"
            subTitle="Next App Solutions - (2023 - Present)"
            result="Remote"
            des="I am the Chief Technical Officer and as well as Product Manager that lead all the technical activity in the company and make sure all teams deliver their tasks assigned"
          />
          <ResumeCard
            title="Full-Stack Developer"
            subTitle="U_I_Dutse Technologies - (2022 - 2023)"
            result="Nigeria"
            des="Create an appealling software that catches clients eyes, using modern tools and technology. Ranging from small businesses, healthcare business and agricultural companies"
          />
          <ResumeCard
            title="Computer Operator"
            subTitle="Sahibul Husni Computer and Business Center - (2016 - 2023)"
            result="Nigeria"
            des="Manage and attend to customers that come to the computer business center."
          />
        </div>
      </div>
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2024</p>
          <h2 className="text-4xl font-bold">Trainer Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Web Development Tutor"
            subTitle="Startup Jigawa (2023 - 2024)"
            result="Jigawa"
            des="Provide trainings youth corps members and students from Federal University Dutse"
          />
          <ResumeCard
            title="Software Engineering Facilitator"
            subTitle="Jigawa Baze University IDEAS Programme (2024 - Present)"
            result="Jigawa"
            des="A programme by Baze University Abuja that provides students with the knowledge of current tech stacks"
          />
          <ResumeCard
            title="Software Development Trainer"
            subTitle="3MTT Jigawa State (2024 - Present)"
            result="Jigawa"
            des="A programme by Three Million Tech Talent where by the government of Nigeria is trying to fill some percent of the global IT shortage."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
